import React from "react";

import { MenuCategoryDto } from "services/menu/restModels";

import { localizedText } from "shared/lib/localizedMap";
import { itemsCountLabel } from "shared/lib/menuLabels";
import { Button, TuneIcon } from "shared/ui";

import { CategoryTitle, Head, Pill, SettingsButton, Spacer } from "./styles";

interface CategoryHeaderProps {
    category: MenuCategoryDto | null;
    locale: string;
    // Сколько позиций в текущей выдаче, когда в поиске есть запрос. Общий счётчик
    // категории при этом остаётся на месте: он объясняет, из чего выбирали.
    foundCount: number | null;
    onOpenSettings: () => void;
}


const scheduleLabel = (category: MenuCategoryDto): string | null => {
    if (!category.schedule.isEnabled) return null;

    return "По расписанию";
};

export const CategoryHeader = ({
    category,
    locale,
    foundCount,
    onOpenSettings,
}: CategoryHeaderProps) => {
    if (!category) return null;

    const schedule = scheduleLabel(category);

    return (
        <Head>
            <CategoryTitle>{localizedText(category.name, locale)}</CategoryTitle>
            <Pill $tone="neutral">{itemsCountLabel(category.itemsCount)}</Pill>
            {foundCount !== null && <Pill $tone="neutral">Найдено · {foundCount}</Pill>}
            {schedule && <Pill $tone="warning">{schedule}</Pill>}
            {category.isInStopList && <Pill $tone="warning">Категория в стоп-листе</Pill>}

            <Spacer />

            <SettingsButton>
                <Button variant="outlined" color="neutral" onClick={onOpenSettings}>
                    <TuneIcon />
                    Настройки категории
                </Button>
            </SettingsButton>
        </Head>
    );
};
